import { Component, inject, Inject, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router, RouterModule } from '@angular/router';

import { StyleClassModule } from 'primeng/styleclass';  
import { AppConfigurator } from '../app.configurator';
import { LayoutService } from '../../service/layout.service';
import IDisplayUsers from '../../../../domain/ports/i-display-users';
import { SelectModule } from 'primeng/select';
import { TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms'; 
import { OidcSecurityService, OpenIdConfiguration } from 'angular-auth-oidc-client';
import { MenuModule } from 'primeng/menu';
import { environment } from '../../../../../environments/environment'; // Importa el entorno para usar la URL de logout
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-client-topbar',
    standalone: true,
    imports: [RouterModule, StyleClassModule, AppConfigurator, SelectModule, FormsModule, MenuModule],
    styleUrl: './app.client.topbar.scss',
    template: ` <div class="layout-topbar layout-client-topbar">
              <div class="layout-topbar-logo-container">
                <a class="layout-topbar-logo" style="width: 30%; margin-right: 10px;" href="https://www.tenaris.com/" >
                  <svg style=" top: 0; left: 0; display: block; width: 100%; height: auto;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140.181 35.663"><path fill="#807e82" fill-rule="evenodd" d="M33.174 9.875v5.271h6.503v19.841h5.43v-19.84h6.506V9.874z"></path><path fill="#807e82" fill-rule="evenodd" d="M57.632 31.436c-2.812 0-4.065-2.31-4.031-4.62h12.633c-.067-2.097-.204-5.72-2.506-8.314a8.356 8.356 0 0 0-6.369-2.665c-6.975 0-9.076 5.756-9.076 10.233 0 6.075 3.692 9.593 8.942 9.593a9.464 9.464 0 0 0 6.672-2.63 14.39 14.39 0 0 0 2.133-2.772l-3.928-2.095c-.643 1.314-1.626 3.27-4.47 3.27zm-2.948-10.483a3.527 3.527 0 0 1 2.642-1.207 3.583 3.583 0 0 1 2.541 1.03 4.533 4.533 0 0 1 .981 2.63h-7.213a4.959 4.959 0 0 1 1.049-2.453zm18.982-2.842a5.165 5.165 0 0 1 1.761-1.457 8.257 8.257 0 0 1 3.218-.676 6.466 6.466 0 0 1 3.15.747c1.863 1.03 2.336 2.7 2.336 5.579v12.684h-5.18V24.542a7.77 7.77 0 0 0-.237-2.771 2.356 2.356 0 0 0-2.337-1.422c-2.744 0-2.744 2.31-2.744 4.618v10.02h-5.216v-18.51h5.249zm28.69 16.877c-.408-.64-.508-.925-.508-2.915v-10.8c0-4.797-5.25-5.33-7.417-5.33a8.764 8.764 0 0 0-5.79 1.635 5.273 5.273 0 0 0-1.865 4.122h5.216a2.409 2.409 0 0 1 2.743-2.168c1.864 0 1.932 1.421 1.999 2.274v.994a43.9 43.9 0 0 0-6.977 1.706 5.957 5.957 0 0 0-3.726 5.33 5.496 5.496 0 0 0 5.792 5.65 8.11 8.11 0 0 0 5.418-2.205v1.707zm-7.45-4.123a3.307 3.307 0 0 1-1.797.606 1.935 1.935 0 0 1-1.964-1.885c0-1.42 1.356-1.953 2.236-2.308l3.353-1.174c-.033 1.92-.101 3.626-1.828 4.761zm14.946-12.504a7.991 7.991 0 0 1 5.114-2.132v4.831l-1.727.285c-2.507.463-3.252.852-3.252 3.197v10.446h-5.216V16.404h5.081z"></path><path fill="#807e82" d="M116.968 16.406h5.147v18.582h-5.147zm0-6.537h5.147v4.228h-5.147z"></path><path fill="#807e82" fill-rule="evenodd" d="M126.531 28.733a7.414 7.414 0 0 0 5.148 2.56c1.254 0 3.15-.428 3.15-1.813a1.13 1.13 0 0 0-.679-1.066 10.794 10.794 0 0 0-3.012-.71 19.034 19.034 0 0 1-2.372-.568 6.558 6.558 0 0 1-2.946-1.598 5.134 5.134 0 0 1-1.322-3.485c0-3.053 2.507-6.215 7.453-6.215a12.593 12.593 0 0 1 7.89 2.77l-3.217 3.127a7.221 7.221 0 0 0-4.437-1.848c-2.033 0-2.506.853-2.506 1.386 0 1.066 1.117 1.278 2.811 1.598 3.557.675 7.689 1.67 7.689 6.077 0 4.37-4.2 6.501-8.367 6.501a11.4 11.4 0 0 1-8.567-3.588z"></path><path fill="#00a84f" d="M0 24.249h26.669v.864H0zM0 9.876h26.669v5.271H0zm0-7.922h26.669v1.32H0z"></path><path fill="#0066b0" d="M0 21.754h26.669v1.319H0zM0 4.891h26.669v2.638H0z"></path><path fill="#a9218e" d="M0 17.5h26.669v2.637H0zM0 0h26.669v.866H0z"></path></svg>
                </a>
                <!-- Language Selector -->
                <!-- Language Selector -->
                <p-select
                  [options]="availableLanguages"
                  [(ngModel)]="selectedLanguage"
                  (onChange)="changeLanguage($event.value)"
                  [placeholder]="selectedLanguage.toUpperCase()"
                  class="language-dropdown transparent-dropdown">
                </p-select>
              </div>
              <div class="layout-topbar-actions">
                <app-configurator></app-configurator>
                <div class="">
                  <div class="w-full " style="text-align: center;">
                    <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>
            
                    @if (isAuthenticated) {
                      <div
                        class="user-menu-toggle cursor-pointer"
                        (click)="menu.toggle($event)"
                        tabindex="0"
                        role="button"
                        >
                        <i id="menuIcon" class="pi pi-user" aria-hidden="true"></i>
                        <span id="userLogged">{{ displayName }}</span>
                      </div>
                    } @else {
                      <div
                        class="user-menu-toggle cursor-pointer"
                        (click)="login()"
                        tabindex="0"
                        role="button"
                        >
                        <i id="menuIcon" class="pi pi-user" aria-hidden="true"></i>
                        <span id="userLogged">LOG IN</span>
                      </div>
                    }
            
            
                  </div>
                </div>
              </div>
            
            
            </div>`
})
export class AppClientTopbar {
    isAuthenticated = false;
    menuItems: any[] = [];
    items!: MenuItem[];
    languages = [
        { label: 'EN', value: 'en' },
        { label: 'ES', value: 'es' }
    ];
    selectedLanguage = 'en'; // Idioma predeterminado

    private readonly oidcSecurityService = inject(OidcSecurityService);
    configurations: OpenIdConfiguration[] | undefined;
    idToken:any; 
    accessToken:any;   
    displayName: string = '';

    constructor(
    public layoutService: LayoutService, 
    @Inject('IDisplayUsers') public userDisplayer: IDisplayUsers,
    private translate: TranslateService,
    private router: Router,
    private http: HttpClient ) {
        this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated, accessToken, idToken, userData }) => {
            this.isAuthenticated = isAuthenticated;
            this.accessToken = accessToken;
            this.idToken = idToken;
            if (isAuthenticated && userData) {          
                this.displayName = userData['nickname'];                                                  
            }
            else {
                this.displayName = '';
            }

            this.buildMenu();
        });
    }

       

     ngOnInit() {
        this.buildMenu();

        window.addEventListener('storage', (event) => {
            if (event.key === 'logout-event') {
                localStorage.clear();
                sessionStorage.clear();
                window.location.reload(); 
            }
        });

        this.translate.onLangChange.subscribe(() => {
            this.buildMenu(); // reconstruyo el menú con las nuevas traducciones
        });
    }

    changeLanguage(lang: string) {
        this.selectedLanguage = lang;
        this.translate.use(lang); // Cambia el idioma
    }

    get availableLanguages() {
        // Sólo las opciones que NO están seleccionadas
        return this.languages.filter(lang => lang.value !== this.selectedLanguage);
    }

    // Función para obtener el label dado el valor
    getLabel(value: string): string {
        const lang = this.languages.find(l => l.value === value);
        return lang ? lang.label : '';
    }

     buildMenu() {
         if (this.isAuthenticated) {
            this.menuItems = [
                {
                    label: this.translate.instant('MENU.LOGOUT'),
                    icon: 'pi pi-sign-out',
                    command: () => {
                        this.oidcSecurityService.logoff();
                        this.logout()
                    }
                }
            ];
        } else {
             this.menuItems = [];
        }
    }

    logout() {   
        localStorage.setItem('logout-event', Date.now().toString());    
        localStorage.clear();
        sessionStorage.clear();
        const postLogoutRedirectUri = encodeURIComponent(environment.urlLogout);
        window.location.replace(`${environment.auth.logout}?client_id=${environment.auth.clientId}&post_logout_redirect_uri=${postLogoutRedirectUri}`);

    }
    

    login(){
         this.oidcSecurityService.authorize();
    }
}
